import { LucideIcon } from 'lucide-react';

import { cn, withTooltip } from '@crossnokaye/ux-common';

interface IconWrapperProps {
  icon: LucideIcon;
  isDisabled: boolean;
  onClick?: () => void;
}

/**
 * Wrapper component that handles hover/active coloring for icons in sequencer table.
 * Shows pointer cursor and primary color on hover when not disabled.
 */
export const IconWrapper = ({ icon: Icon, isDisabled, onClick, ...props }: IconWrapperProps) => {
  return (
    <Icon
      {...props}
      className={cn('w-4 h-4', !isDisabled && 'hover:text-primary hover:cursor-pointer')}
      onClick={onClick}
    />
  );
};

export const IconWithTooltip = withTooltip(IconWrapper);
